import { render, staticRenderFns } from "./verbaende.vue?vue&type=template&id=4a588dbf&scoped=true"
import script from "./verbaende.vue?vue&type=script&lang=js"
export * from "./verbaende.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a588dbf",
  null
  
)

export default component.exports